import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  ProgressBar,
  Tab,
  Tabs,
  Badge,
  Accordion,
  Modal,
  ListGroup,
  FormCheck,
} from "react-bootstrap";
import {
  FaUser,
  FaBuilding,
  FaFileAlt,
  FaCheck,
  FaUpload,
  FaPhone,
  FaEnvelope,
  FaCalendarAlt,
  FaIdCard,
  FaShieldAlt,
  FaRegBuilding,
  FaMapMarkerAlt,
  FaInfoCircle,
  FaTimes,
  FaPrint,
  FaSearch,
  FaExternalLinkAlt,
  FaEdit,
  FaBank,
  FaUserShield,
} from "react-icons/fa";
import { MdPerson, MdWork, MdDescription, MdAssignment } from "react-icons/md";
import { CiBank } from "react-icons/ci";
import "../../styles/AgencyOnBoard.css";
import axios from "axios";
import { Baseurl, Imageurl } from "../../baseurl";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const AddEmployee = () => {
  const { loginData } = useSelector((store) => store.auth);
  const [activeTab, setActiveTab] = useState("personal");
  const [formData, setFormData] = useState({
    // Personal Details
    name: "",
    fatherName: "",
    dOB: "",
    mobileNo: "",
    email: "",
    password: "",

    // Organisation Details
    organisation: {
      name: "",
      phn: "",
      email: "",
    },

    // Address Details
    currentAddress: "",

    // Personal Documents
    addressProof: null,
    panCard: "",
    supportingDocument: null,

    // Bank Details
    bankDetails: {
      bankAccountNo: "",
      ifscCode: "",
      bankName: "",
      cancelledCheque: null,
    },

    // Compliance
    compliance: {
      DRACertificate: null,
      policeVerificationReport: null,
    },

    // Role and Status
    role: "agent",
    empStatus: "Pending",
    permissions: [],
    applicationID: "",
  });

  console.log(loginData, "loginData");
  const [uploadProgress, setUploadProgress] = useState({});
  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [applicationStatusData, setApplicationStatusData] = useState(null);
  const [checkApplicationID, setCheckApplicationID] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [fileStatus, setFileStatus] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);

  // Permissions options
  const permissionOptions = [
    {
      id: "case_management",
      label: "Case Management",
      description: "Access to create, view, and manage cases",
    },
    {
      id: "yard_management",
      label: "Yard Management",
      description: "Manage yard operations and inventory",
    },
    {
      id: "employee_management",
      label: "Employee Management",
      description: "Add, edit, and manage employees",
    },
  ];

  // Initialize file status from form data on component mount
  useEffect(() => {
    const status = {};
    const files = {};

    // Check personal documents
    if (formData.addressProof) {
      status["addressProof"] = "Uploaded";
      files["addressProof"] = formData.addressProof;
    }
    if (formData.supportingDocument) {
      status["supportingDocument"] = "Uploaded";
      files["supportingDocument"] = formData.supportingDocument;
    }

    // Check bank documents
    if (formData.bankDetails?.cancelledCheque) {
      status["bankDetails.cancelledCheque"] = "Uploaded";
      files["bankDetails.cancelledCheque"] =
        formData.bankDetails.cancelledCheque;
    }

    // Check compliance documents
    if (formData.compliance?.DRACertificate) {
      status["compliance.DRACertificate"] = "Uploaded";
      files["compliance.DRACertificate"] = formData.compliance.DRACertificate;
    }
    if (formData.compliance?.policeVerificationReport) {
      status["compliance.policeVerificationReport"] = "Uploaded";
      files["compliance.policeVerificationReport"] =
        formData.compliance.policeVerificationReport;
    }

    setFileStatus(status);
    setUploadedFiles(files);
  }, []);
  useEffect(() => {
    if (!loginData) return;

    const organisationData =
      loginData.role === "Agency"
        ? {
            id: loginData._id,
            email: loginData.companyDetails?.email,
            name: loginData.companyDetails?.companyName,
            phn: loginData.companyDetails?.contactNumber,
            logo: loginData?.logo,
          }
        : {
            id: loginData.organisation?.id,
            email: loginData.organisation?.email,
            name: loginData.organisation?.name,
            phn: loginData.organisation?.phn,
            logo: loginData.organisation?.logo,
          };

    setFormData((prevData) => ({
      ...prevData,
      organisation: organisationData,
    }));
  }, [loginData]);

  console.log(formData, "formData");

  // Calculate form completion percentage
  const calculateProgress = () => {
    const fields = [
      formData.name,
      formData.fatherName,
      formData.dOB,
      formData.mobileNo,
      formData.email,
      formData.password,
      formData.panCard,
      formData.currentAddress,
      formData.organisation.name,
      formData.organisation.phn,
      formData.organisation.email,
      formData.bankDetails.bankAccountNo,
      formData.bankDetails.ifscCode,
      formData.bankDetails.bankName,
    ];

    const filledFields = fields.filter(
      (field) => field && field.toString().trim() !== "",
    ).length;
    return Math.round((filledFields / fields.length) * 100);
  };

  const handleInputChange = (section, field, value) => {
    if (section) {
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  // Handle permission toggle
  const handlePermissionToggle = (permissionId) => {
    setFormData((prev) => {
      const currentPermissions = [...prev.permissions];

      if (currentPermissions.includes(permissionId)) {
        // Remove permission if already exists
        return {
          ...prev,
          permissions: currentPermissions.filter((id) => id !== permissionId),
        };
      } else {
        // Add permission if not exists
        return {
          ...prev,
          permissions: [...currentPermissions, permissionId],
        };
      }
    });
  };

  const handleRemoveData = async () => {
    setFormData({
      name: "",
      fatherName: "",
      dOB: "",
      mobileNo: "",
      email: "",
      password: "",
      organisation: {
        name: "",
        phn: "",
        email: "",
      },
      currentAddress: "",
      addressProof: null,
      panCard: "",
      supportingDocument: null,
      bankDetails: {
        bankAccountNo: "",
        ifscCode: "",
        bankName: "",
        cancelledCheque: null,
      },
      compliance: {
        DRACertificate: null,
        policeVerificationReport: null,
      },
      role: "agent",
      empStatus: "Pending",
      permissions: [],
      applicationID: "",
    });
    setFileStatus({});
    setUploadedFiles({});
    setShowSuccessModal(false);
    setModalData("");
    setIsEditMode(false);
  };

  const handleFileUpload = async (section, field, file) => {
    if (!file) return;

    const key = section ? `${section}.${field}` : field;
    setUploadProgress((prev) => ({ ...prev, [key]: 0 }));

    const formDataObj = new FormData();
    formDataObj.append("file", file);

    try {
      const res = await axios.post(`${Imageurl}/agency`, formDataObj, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setUploadProgress((prev) => ({ ...prev, [key]: percent }));
        },
      });

      // Store uploaded file URL
      if (section) {
        handleInputChange(section, field, res.data.filePath);
      } else {
        handleInputChange(null, field, res.data.filePath);
      }

      // Update file status and store file info
      setFileStatus((prev) => ({ ...prev, [key]: "Uploaded" }));
      setUploadedFiles((prev) => ({ ...prev, [key]: file.name }));

      toast.success(`${field} uploaded successfully!`);

      // Clear progress after 2 seconds
      setTimeout(() => {
        setUploadProgress((prev) => ({ ...prev, [key]: 0 }));
      }, 2000);
    } catch (error) {
      console.error("File upload failed:", error);
      setUploadProgress((prev) => ({ ...prev, [key]: 0 }));
      toast.error("File upload failed. Please try again.");
    }
  };

  const removeUploadedFile = (section, field) => {
    const key = section ? `${section}.${field}` : field;

    if (section) {
      handleInputChange(section, field, null);
    } else {
      handleInputChange(null, field, null);
    }

    setFileStatus((prev) => {
      const newStatus = { ...prev };
      delete newStatus[key];
      return newStatus;
    });
    setUploadedFiles((prev) => {
      const newFiles = { ...prev };
      delete newFiles[key];
      return newFiles;
    });
    toast.info(`File removed from ${field}`);
  };
  console.log(formData, "formData");
  const validateForm = () => {
    const newErrors = {};

    // Personal details validation
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.mobileNo.match(/^[0-9]{10}$/))
      newErrors.mobileNo = "Invalid mobile number";
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      newErrors.email = "Invalid email";
    if (!formData.panCard.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
      newErrors.panCard = "Invalid PAN format";
    }

    // Organisation validation
    if (!formData.organisation.name.trim()) {
      newErrors.organisationName = "Organisation name is required";
    }

    // Bank details validation
    if (!formData.bankDetails.bankAccountNo.trim()) {
      newErrors.bankAccountNo = "Bank account number is required";
    }
    if (!formData.bankDetails.ifscCode.match(/^[A-Z]{4}0[A-Z0-9]{6}$/)) {
      newErrors.ifscCode = "Invalid IFSC Code format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const url = `${Baseurl}/api/fieldOfficer/create`;
      try {
        const resp = await axios.post(url, formData, config);
        if (resp.data.success) {
          setModalData(resp.data?.data);
          setShowSuccessModal(true);
          setIsEditMode(false);
          toast.success(resp.data?.message);
        }
      } catch (error) {
        toast.error("Failed to submit application. Please try again.");
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const url = `${Baseurl}/api/fieldOfficer/update/${formData._id}`;
      try {
        const resp = await axios.put(url, formData, config);
        if (resp.data.success) {
          setModalData(resp.data?.data);
          setShowSuccessModal(true);
          setIsEditMode(false);
          toast.success(resp.data?.message);
        }
      } catch (error) {
        toast.error("Failed to submit application. Please try again.");
      }
    }
  };

  const handleCheckStatus = async () => {
    if (!checkApplicationID.trim()) {
      toast.error("Please enter Application ID");
      return;
    }

    try {
      const url = `${Baseurl}/api/fieldOfficer/status/${checkApplicationID}`;
      const resp = await axios.get(url);

      if (resp.data.success) {
        setApplicationStatusData(resp.data.data);
      } else {
        toast.error(resp.data.message || "Application not found");
      }
    } catch (error) {
      toast.error("Failed to fetch application status");
    }
  };

  const handleEditAndResubmit = () => {
    if (applicationStatusData) {
      // Populate form with existing data for editing
      setFormData({
        ...applicationStatusData,
        empStatus: "Pending", // Reset status for resubmission
      });

      // Update file status for uploaded files
      const status = {};
      if (applicationStatusData.addressProof) {
        status["addressProof"] = "Uploaded";
      }
      if (applicationStatusData.supportingDocument) {
        status["supportingDocument"] = "Uploaded";
      }
      if (applicationStatusData.bankDetails?.cancelledCheque) {
        status["bankDetails.cancelledCheque"] = "Uploaded";
      }
      if (applicationStatusData.compliance?.DRACertificate) {
        status["compliance.DRACertificate"] = "Uploaded";
      }
      if (applicationStatusData.compliance?.policeVerificationReport) {
        status["compliance.policeVerificationReport"] = "Uploaded";
      }

      setFileStatus(status);
      setIsEditMode(true);
      setShowStatusModal(false);
      toast.info("You can now edit and resubmit your application");
    }
  };

  const renderFileStatus = (section, field) => {
    const key = section ? `${section}.${field}` : field;
    const isUploaded = fileStatus[key] === "Uploaded";
    const isUploading = uploadProgress[key] > 0 && uploadProgress[key] < 100;

    if (!isUploaded && !isUploading) return null;

    return (
      <div className="d-flex align-items-center mt-1">
        {isUploading ? (
          <>
            <div className="spinner-border spinner-border-sm text-primary me-2" />
            <span className="text-muted small">
              Uploading... {uploadProgress[key]}%
            </span>
          </>
        ) : (
          <>
            <Badge bg="success" className="me-2">
              <FaCheck size={10} /> Uploaded
            </Badge>
            <span className="text-muted small me-2">
              {uploadedFiles[key] || "File uploaded"}
            </span>
            <Button
              variant="link"
              size="sm"
              className="p-0 text-danger"
              onClick={() => removeUploadedFile(section, field)}
            >
              <FaTimes size={12} />
            </Button>
          </>
        )}
      </div>
    );
  };

  const renderStatusModalContent = () => {
    if (!applicationStatusData) {
      return (
        <div className="text-center py-4">
          <FaSearch size={48} className="text-muted mb-3" />
          <p>Enter your Application ID to check status</p>
        </div>
      );
    }

    const { empStatus, applicationID, name, organisation } =
      applicationStatusData;

    const statusConfig = {
      Pending: {
        variant: "warning",
        icon: <FaInfoCircle className="me-2" />,
        title: "Application Under Review",
        message:
          "We are processing your application. Please check back in 24-48 hours.",
        actions: [],
      },
      Approved: {
        variant: "success",
        icon: <FaCheck className="me-2" />,
        title: "Application Approved!",
        message:
          "Congratulations! Your application has been verified successfully.",
        actions: [
          {
            label: "Login to Admin Panel",
            variant: "success",
            onClick: () =>
              window.open("https://auction.mcollect.co.in/", "_blank"),
            icon: <FaExternalLinkAlt className="me-2" />,
          },
        ],
      },
      Rework: {
        variant: "warning",
        icon: <FaEdit className="me-2" />,
        title: "Application Requires Rework",
        message:
          "Oops! Your application needs some corrections. Please edit and resubmit.",
        actions: [
          {
            label: "Edit and Resubmit",
            variant: "warning",
            onClick: handleEditAndResubmit,
            icon: <FaEdit className="me-2" />,
          },
        ],
      },
      Rejected: {
        variant: "danger",
        icon: <FaTimes className="me-2" />,
        title: "Application Rejected",
        message:
          "We cannot proceed with your application at this time. Sorry for the inconvenience.",
        actions: [],
      },
    };

    const config = statusConfig[empStatus] || statusConfig.Pending;

    return (
      <>
        <div className="text-center mb-4">
          <div
            className={`bg-${config.variant}-subtle p-4 rounded-circle d-inline-block`}
          >
            {config.icon}
          </div>
          <h4 className="mt-3">{config.title}</h4>
        </div>

        <ListGroup className="mb-4">
          <ListGroup.Item>
            <strong>Application ID:</strong> {applicationID}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Applicant Name:</strong> {name}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Organisation:</strong> {organisation?.name}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Status:</strong>{" "}
            <Badge bg={config.variant}>{empStatus}</Badge>
          </ListGroup.Item>
        </ListGroup>

        <Alert variant={config.variant}>{config.message}</Alert>

        {config.actions.map((action, index) => (
          <Button
            key={index}
            variant={action.variant}
            className="w-100 mb-2"
            onClick={action.onClick}
          >
            {action.icon}
            {action.label}
          </Button>
        ))}
      </>
    );
  };

  const renderPersonalDetails = () => (
    <Card className="mb-4">
      <Card.Header className="bg-primary text-white d-flex align-items-center">
        <FaUser className="me-2" />
        <h5 className="mb-0">
          Personal Details {isEditMode && <Badge bg="warning">Editing</Badge>}
        </h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <MdPerson className="me-2" />
                Full Name *
              </Form.Label>
              <Form.Control
                type="text"
                value={formData.name}
                onChange={(e) =>
                  handleInputChange(null, "name", e.target.value)
                }
                isInvalid={!!errors.name}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaUser className="me-2" />
                Father's Name
              </Form.Label>
              <Form.Control
                type="text"
                value={formData.fatherName}
                onChange={(e) =>
                  handleInputChange(null, "fatherName", e.target.value)
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaCalendarAlt className="me-2" />
                Date of Birth
              </Form.Label>
              <Form.Control
                type="date"
                value={formData.dOB}
                onChange={(e) => handleInputChange(null, "dOB", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaPhone className="me-2" />
                Mobile Number *
              </Form.Label>
              <Form.Control
                type="tel"
                value={formData.mobileNo}
                onChange={(e) =>
                  handleInputChange(null, "mobileNo", e.target.value)
                }
                isInvalid={!!errors.mobileNo}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobileNo}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaEnvelope className="me-2" />
                Email *
              </Form.Label>
              <Form.Control
                type="email"
                value={formData.email}
                onChange={(e) =>
                  handleInputChange(null, "email", e.target.value)
                }
                isInvalid={!!errors.email}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaShieldAlt className="me-2" />
                Password
              </Form.Label>
              <Form.Control
                type="password"
                value={formData.password}
                onChange={(e) =>
                  handleInputChange(null, "password", e.target.value)
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaMapMarkerAlt className="me-2" />
                Current Address *
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={formData.currentAddress}
                onChange={(e) =>
                  handleInputChange(null, "currentAddress", e.target.value)
                }
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Accordion className="mt-4">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <FaFileAlt className="me-2" />
              Personal Documents
            </Accordion.Header>
            <Accordion.Body>
              <Form.Group className="mb-3">
                <Form.Label>
                  <FaIdCard className="me-2" />
                  PAN Card Number *
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="ABCDE1234F"
                  value={formData.panCard}
                  onChange={(e) =>
                    handleInputChange(null, "panCard", e.target.value)
                  }
                  isInvalid={!!errors.panCard}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.panCard}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <FaUpload className="me-2" />
                  PAN Card Image
                </Form.Label>
                <Form.Control
                  type="file"
                  onChange={(e) =>
                    handleFileUpload(
                      null,
                      "supportingDocument",
                      e.target.files[0],
                    )
                  }
                />
                {renderFileStatus(null, "supportingDocument")}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <FaMapMarkerAlt className="me-2" />
                  Address Proof
                </Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) =>
                    handleFileUpload(null, "addressProof", e.target.files[0])
                  }
                />
                {renderFileStatus(null, "addressProof")}
                <Form.Text className="text-muted">
                  Aadhar Card, Voter ID, Driving License, etc.
                </Form.Text>
              </Form.Group>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Card.Body>
    </Card>
  );

  const renderOrganisationDetails = () => (
    <Card className="mb-4">
      <Card.Header className="bg-info text-white d-flex align-items-center">
        <FaBuilding className="me-2" />
        <h5 className="mb-0">Organisation Details</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaRegBuilding className="me-2" />
                Organisation Name *
              </Form.Label>
              <Form.Control
                type="text"
                value={formData.organisation.name}
                onChange={(e) =>
                  handleInputChange("organisation", "name", e.target.value)
                }
                isInvalid={!!errors.organisationName}
                required
                readOnly={!!loginData}
              />
              <Form.Control.Feedback type="invalid">
                {errors.organisationName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaPhone className="me-2" />
                Organisation Phone
              </Form.Label>
              <Form.Control
                type="tel"
                value={formData.organisation.phn}
                onChange={(e) =>
                  handleInputChange("organisation", "phn", e.target.value)
                }
                readOnly={!!loginData}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaEnvelope className="me-2" />
                Organisation Email
              </Form.Label>
              <Form.Control
                type="email"
                value={formData.organisation.email}
                onChange={(e) =>
                  handleInputChange("organisation", "email", e.target.value)
                }
                readOnly={!!loginData || formData.organisation.email!==""}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Role *</Form.Label>
          <Form.Select
            value={formData.role}
            onChange={(e) => handleInputChange(null, "role", e.target.value)}
          >
            <option value="agent">Agent</option>
            <option value="yardOwner">Yard Owner</option>
            <option value="inspector">Inspector</option>
          </Form.Select>
        </Form.Group>
      </Card.Body>
    </Card>
  );

  const renderBankDetails = () => (
    <Card className="mb-4">
      <Card.Header className="bg-success text-white d-flex align-items-center">
        <CiBank className="me-2" />
        <h5 className="mb-0">Bank Details</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Bank Account Number *</Form.Label>
              <Form.Control
                type="text"
                value={formData.bankDetails.bankAccountNo}
                onChange={(e) =>
                  handleInputChange(
                    "bankDetails",
                    "bankAccountNo",
                    e.target.value,
                  )
                }
                isInvalid={!!errors.bankAccountNo}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.bankAccountNo}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>IFSC Code *</Form.Label>
              <Form.Control
                type="text"
                placeholder="SBIN0001234"
                value={formData.bankDetails.ifscCode}
                onChange={(e) =>
                  handleInputChange("bankDetails", "ifscCode", e.target.value)
                }
                isInvalid={!!errors.ifscCode}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.ifscCode}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Bank Name *</Form.Label>
              <Form.Control
                type="text"
                value={formData.bankDetails.bankName}
                onChange={(e) =>
                  handleInputChange("bankDetails", "bankName", e.target.value)
                }
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaFileAlt className="me-2" />
                Cancelled Cheque
              </Form.Label>
              <Form.Control
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) =>
                  handleFileUpload(
                    "bankDetails",
                    "cancelledCheque",
                    e.target.files[0],
                  )
                }
              />
              {renderFileStatus("bankDetails", "cancelledCheque")}
              <Form.Text className="text-muted">
                Upload a clear image of cancelled cheque
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  const renderComplianceDetails = () => (
    <Card className="mb-4">
      <Card.Header className="bg-warning text-dark d-flex align-items-center">
        <MdAssignment className="me-2" />
        <h5 className="mb-0">Compliance Documents</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>
            <FaFileAlt className="me-2" />
            DRA Certificate
          </Form.Label>
          <Form.Control
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(e) =>
              handleFileUpload(
                "compliance",
                "DRACertificate",
                e.target.files[0],
              )
            }
          />
          {renderFileStatus("compliance", "DRACertificate")}
          <Form.Text className="text-muted">
            Upload DRA certification document
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            <FaShieldAlt className="me-2" />
            Police Verification Report
          </Form.Label>
          <Form.Control
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(e) =>
              handleFileUpload(
                "compliance",
                "policeVerificationReport",
                e.target.files[0],
              )
            }
          />
          {renderFileStatus("compliance", "policeVerificationReport")}
          <Form.Text className="text-muted">
            Police verification report not older than 6 months
          </Form.Text>
        </Form.Group>
      </Card.Body>
    </Card>
  );

  const renderPermissionsDetails = () => (
    <Card className="mb-4">
      <Card.Header className="bg-secondary text-white d-flex align-items-center">
        <FaUserShield className="me-2" />
        <h5 className="mb-0">Access Permissions</h5>
      </Card.Header>
      <Card.Body>
        <Alert variant="info" className="mb-4">
          <FaInfoCircle className="me-2" />
          Select the permissions you want to grant to this field officer. These
          permissions will determine what modules and features they can access.
        </Alert>

        <div className="permissions-grid">
          <Row>
            {permissionOptions.map((permission) => (
              <Col md={6} key={permission.id} className="mb-3">
                <Card
                  className={`h-100 ${formData.permissions.includes(permission.id) ? "border-primary" : ""}`}
                >
                  <Card.Body>
                    <div className="d-flex align-items-center">
                      <FormCheck
                        type="switch"
                        id={`permission-${permission.id}`}
                        checked={formData.permissions.includes(permission.id)}
                        onChange={() => handlePermissionToggle(permission.id)}
                        label={permission.label}
                        className="mb-0"
                      />
                      {formData.permissions.includes(permission.id) && (
                        <Badge bg="success" className="ms-2">
                          <FaCheck size={10} />
                        </Badge>
                      )}
                    </div>
                    <p className="text-muted small mt-2 mb-0">
                      {permission.description}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        <Card className="mt-4">
          <Card.Header className="bg-light">
            <h6 className="mb-0">Selected Permissions</h6>
          </Card.Header>
          <Card.Body>
            {formData.permissions.length > 0 ? (
              <div className="selected-permissions">
                <Row>
                  {formData.permissions.map((permId) => {
                    const permission = permissionOptions.find(
                      (p) => p.id === permId,
                    );
                    return permission ? (
                      <Col md={4} key={permId} className="mb-2">
                        <Badge
                          bg="primary"
                          className="p-2 w-100 d-flex align-items-center justify-content-between"
                        >
                          <span>{permission.label}</span>
                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 text-white"
                            onClick={() => handlePermissionToggle(permId)}
                          >
                            <FaTimes size={12} />
                          </Button>
                        </Badge>
                      </Col>
                    ) : null;
                  })}
                </Row>
                <div className="mt-3 text-center">
                  <Badge bg="info" className="p-2">
                    Total Selected: {formData.permissions.length} permission(s)
                  </Badge>
                </div>
              </div>
            ) : (
              <div className="text-center text-muted py-3">
                <FaInfoCircle className="me-2" />
                No permissions selected. Please select at least one permission.
              </div>
            )}
          </Card.Body>
        </Card>
      </Card.Body>
    </Card>
  );

  return (
    <Container fluid className="py-4">
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="d-flex align-items-center">
                <FaUser className="me-3" />
                Field Officer Onboarding
              </h2>
              <p className="text-muted">
                Register a new field officer with complete details
              </p>
            </div>
            <Button
              variant="outline-primary"
              onClick={() => setShowStatusModal(true)}
            >
              <FaSearch className="me-2" />
              Check Application Status
            </Button>
          </div>
        </Col>
      </Row>

      {/* Progress Bar */}
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span>Form Completion</span>
                <span>{calculateProgress()}%</span>
              </div>
              <ProgressBar
                now={calculateProgress()}
                label={`${calculateProgress()}%`}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Navigation Tabs */}
      <Row className="mb-4">
        <Col>
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
            fill
          >
            <Tab
              eventKey="personal"
              title={
                <span>
                  <FaUser className="me-2" />
                  Personal Details
                </span>
              }
            />
            <Tab
              eventKey="organisation"
              title={
                <span>
                  <FaBuilding className="me-2" />
                  Organisation Details
                </span>
              }
            />
            <Tab
              eventKey="bank"
              title={
                <span>
                  <CiBank className="me-2" />
                  Bank Details
                </span>
              }
            />
            <Tab
              eventKey="compliance"
              title={
                <span>
                  <MdAssignment className="me-2" />
                  Compliance
                </span>
              }
            />
            <Tab
              eventKey="permissions"
              title={
                <span>
                  <FaUserShield className="me-2" />
                  Permissions
                </span>
              }
            />
          </Tabs>
        </Col>
      </Row>

      <Form onSubmit={isEditMode ? handleUpdate : handleSubmit}>
        {/* Conditional Rendering based on active tab */}
        {activeTab === "personal" && renderPersonalDetails()}
        {activeTab === "organisation" && renderOrganisationDetails()}
        {activeTab === "bank" && renderBankDetails()}
        {activeTab === "compliance" && renderComplianceDetails()}
        {activeTab === "permissions" && renderPermissionsDetails()}

        {/* Navigation Buttons */}
        <Row className="mt-4">
          <Col className="d-flex justify-content-between">
            <Button
              variant="outline-secondary"
              onClick={() => {
                const tabs = [
                  "personal",
                  "organisation",
                  "bank",
                  "compliance",
                  "permissions",
                ];
                const currentIndex = tabs.indexOf(activeTab);
                if (currentIndex > 0) setActiveTab(tabs[currentIndex - 1]);
              }}
              disabled={activeTab === "personal"}
            >
              Previous
            </Button>

            {activeTab !== "permissions" ? (
              <Button
                variant="primary"
                onClick={() => {
                  const tabs = [
                    "personal",
                    "organisation",
                    "bank",
                    "compliance",
                    "permissions",
                  ];
                  const currentIndex = tabs.indexOf(activeTab);
                  if (currentIndex < tabs.length - 1)
                    setActiveTab(tabs[currentIndex + 1]);
                }}
              >
                Next
              </Button>
            ) : (
              <Button variant="success" type="submit">
                <FaCheck className="me-2" />
                {isEditMode ? "Resubmit Application" : "Submit Application"}
              </Button>
            )}
          </Col>
        </Row>
      </Form>

      {/* Success Modal */}
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)}>
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title>
            <FaCheck className="me-2" />
            Application Submitted Successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="success">
            <Alert.Heading>Application Received</Alert.Heading>
            <p>
              Your field officer onboarding application has been submitted
              successfully. Your application ID is{" "}
              <strong>{modalData?.applicationID}</strong>.
            </p>
            <hr />
            <p className="mb-0">
              The application is now in <Badge bg="warning">Pending</Badge>{" "}
              status. You will be notified via email once the verification is
              complete.
            </p>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleRemoveData()}>
            Close
          </Button>
          <Button
            variant="outline-success"
            onClick={() => {
              window.print();
              handleRemoveData();
            }}
          >
            <FaPrint className="me-2" />
            Print Application
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Application Status Check Modal */}
      <Modal
        show={showStatusModal}
        onHide={() => setShowStatusModal(false)}
        size="lg"
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <FaSearch className="me-2" />
            Check Application Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!applicationStatusData ? (
            <>
              <Form.Group className="mb-4">
                <Form.Label>
                  <FaIdCard className="me-2" />
                  Enter Application ID
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g., APP2023001"
                  value={checkApplicationID}
                  onChange={(e) => setCheckApplicationID(e.target.value)}
                />
                <Form.Text className="text-muted">
                  You can find your Application ID in your email or application
                  confirmation.
                </Form.Text>
              </Form.Group>
              <Button
                variant="primary"
                className="w-100"
                onClick={handleCheckStatus}
              >
                <FaSearch className="me-2" />
                Check Status
              </Button>
            </>
          ) : (
            renderStatusModalContent()
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowStatusModal(false);
              setApplicationStatusData(null);
              setCheckApplicationID("");
            }}
          >
            Close
          </Button>
          {applicationStatusData && (
            <Button
              variant="outline-primary"
              onClick={() => {
                setApplicationStatusData(null);
                setCheckApplicationID("");
              }}
            >
              Check Another Application
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AddEmployee;
